<script lang="ts" setup>
import ActiveButtons from '@/components/ActiveButtons/ActiveButtons.vue'
import BreadcrumbsElement from '@/components/BreadcrumbsElement/BreadcrumbsElement.vue'
import { heroBannerDefaultProps } from '@/components/HeroBanner/HeroBanner.constants'
import ActionIcons from '@/components/Markets/ActionIcons/ActionIcons.vue'

import type { HeroBannerProps } from '@/components/HeroBanner/HeroBanner.types'

withDefaults(defineProps<HeroBannerProps>(), heroBannerDefaultProps as any)

const isHtmlContent = (str: string | undefined) => {
  if (!str) return false
  const htmlPattern = /<[^>]+>/
  return htmlPattern.test(str)
}
</script>
<template>
  <section class="relative bg-black">
    <div
      class="max-w-1200 mx-auto lg:pt-10 px-2.5 1200:px-0 lg:pb-[141px] pb-20 flex flex-col lg:items-start items-center"
    >
      <BreadcrumbsElement v-if="withBreadcrumbs" class="relative z-10" />
      <div
        v-if="isHtmlContent(title)"
        class="text-white lg:mt-[101px] mt-[37px] lg:h1-bold h3-bold relative z-10 self-center lg:self-start text-center lg:text-start"
        v-html="title"
      ></div>

      <h1
        v-else
        class="text-white lg:mt-[101px] mt-[37px] lg:h1-bold h3-bold relative z-10 self-center lg:self-start text-center lg:text-start"
      >
        {{ title }}
      </h1>
      <div
        v-if="subTitle"
        class="self-center text-white lg:h5-bold nav lg:self-start lg:mt-[10px] mt-[8px] text-center relative z-10"
        v-html="subTitle"
      ></div>

      <div :class="['def:mt-[63px] w-full lg:w-auto relative z-10', actionIconsCssClass]">
        <slot name="activeButtons">
          <ActionIcons
            v-if="withActionIcons"
            :apple-link="actionIcons?.appleLink"
            :google-link="actionIcons?.googleLink"
            :google-button-images="actionIcons?.googleButtonImages"
            :apple-button-images="actionIcons?.appleButtonImages"
            apple-store-button
            google-play-button
            loading="eager"
          ></ActionIcons>
          <ActiveButtons
            v-if="withActiveButtons"
            :left-button="activeButtons?.leftButton"
            :right-button="activeButtons?.rightButton"
            :only-left-button="onlyLeftButton"
            mode="dark"
            position="left"
          ></ActiveButtons>
        </slot>
      </div>

      <img
        v-if="pattern"
        :src="`/assets/bg_patterns/${pattern}.webp`"
        alt="bg pattern"
        class="absolute top-0 bottom-0 right-0 z-0 hidden object-cover h-full lg:block"
        loading="lazy"
      />
      <img
        v-if="patternMobile"
        :src="`/assets/bg_patterns/${patternMobile}.webp`"
        alt="bg pattern"
        class="absolute top-0 bottom-0 right-0 z-0 block object-cover h-full lg:hidden"
        loading="lazy"
      />
      <img
        v-if="butterPattern"
        :src="butterPattern"
        alt="bg pattern"
        class="absolute top-0 bottom-0 right-0 z-0 hidden object-cover h-full lg:block"
        loading="lazy"
      />
      <img
        v-if="butterPatternMobile"
        :src="butterPatternMobile"
        alt="bg pattern"
        class="absolute top-0 bottom-0 right-0 z-0 block object-cover h-full lg:hidden"
        loading="lazy"
      />

      <slot></slot>
    </div>
  </section>
</template>
